module.exports = __webpack_public_path__ + "img/truck-delivery.de197b1a.svg";